export default "__VITE_ASSET__BFzps9wp__"